import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { AdType } from "@m19-board/shared/compact-filter/compact-filter.component";

@Component({
  selector: "app-ad-type-formatter",
  imports: [TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      @for (value of values(); track value) {
        {{ value === AdType.SponsoredAds ? t("common.sponsored_ads") : t("common.dsp") }}
        @if (!$last) {
          <span class="text-gray-400">, </span>
        }
      }
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdTypeFormatterComponent {
  readonly AdType = AdType;

  readonly values = input.required<AdType[]>();
}
